import { render, staticRenderFns } from "./PurchaseForm.vue?vue&type=template&id=a59c1408&scoped=true"
import script from "./PurchaseForm.vue?vue&type=script&lang=js"
export * from "./PurchaseForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaseForm.vue?vue&type=style&index=0&id=a59c1408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59c1408",
  null
  
)

export default component.exports